import { batchReducer, examType } from "./reducers/batchReducer";
import { createStore, combineReducers } from "redux";

const reducers = combineReducers({
    batchReducer,
    examReducer: examType
})

export const store = createStore(reducers);